module.exports = __webpack_public_path__ + "static/BalletDoodle2-086e51161960c5e871ba11bb5bf0ee55.png";